<div class="row">
  <div class="col-auto position-relative mt-3 mx-auto">
    <img class="img-fluid" src="assets/logout.svg" alt="Logout Image">
    <div id="msg-container">
      <h1 class="fw-normal mt-lg-3">You have logged out successfully</h1>
      <a class="btn btn-primary" role="button" [href]="loginToHome">Login Again</a>
    </div>
  </div>
</div>
